import React from 'react';
import { IPageName, getPath } from '@secretescapes/cauldron';
import {
  IllustrationIcon,
  IllustrationMode,
  IllustrationSize,
  InfoBox,
  InfoBoxVariant,
  Scale,
} from '@secretescapes/falcon';
import { i18n } from '@secretescapes/i18n';
import { useApplicationState } from '@utils/useApplicationState';
import { useServerState } from '@utils/useServerState';
import { useTranslations } from '@utils/useTranslations';

interface OmnibusDirectiveProps {
  isMobile: boolean;
}

export const OmnibusDirective = ({ isMobile }: OmnibusDirectiveProps) => {
  const { territoryCode } = useApplicationState();
  const { sale } = useServerState();
  const { translations } = useTranslations();

  const hotelName = sale?.hotelName ?? '';
  const termsAndConditionsLink = getPath(IPageName.termsAndConditions, territoryCode) ?? '';

  const illustrationConfig = !isMobile
    ? { icon: IllustrationIcon.Hand, mode: IllustrationMode.light, size: IllustrationSize.xs }
    : undefined;

  return (
    <InfoBox
      title={i18n('sale.omnibus.directive.title', [], translations)}
      subTitle={i18n(
        'sale.omnibus.directive.subtitle',
        [hotelName, termsAndConditionsLink],
        translations
      )}
      variant={InfoBoxVariant.safety}
      borderConfig={{
        radius: Scale.xxs,
        showLeftLip: false,
      }}
      illustrationConfig={illustrationConfig}
      dataAttributes={{ testid: 'omnibus-directive' }}
    />
  );
};
